// extracted by mini-css-extract-plugin
module.exports = {"burgerButton":"BurgerButton_burgerButton__yBU75","burgerButtonActive":"BurgerButton_burgerButtonActive___MXeO"};